<template>
  <div class="formulaire-info-sante-fftri">
    <p class="font-weight-bold mb-1">Formulaire Info Santé (FIS)</p>
    <p class="text-body-2 mb-2">{{ intro }}</p>


    <section v-for="section in sections" :key="section.id" class="mb-5">
      <div class="mb-3 text-h5">
        <span class="font-weight-bold">{{ section.title }}</span>
      </div>

      <p v-if="section.intro" class=" mb-2">{{ section.intro }}</p>

      <ul v-if="section.questions?.length" class="fis-list mb-3">
        <li v-for="(question, index) in section.questions" :key="index" class="mb-2">
          <template v-if="typeof question === 'string'">{{ question }}</template>
          <template v-else>
            <span>{{ question.text }}</span>
            <ul v-if="question.subItems?.length" class="fis-sublist mt-1">
              <li v-for="(sub, subIndex) in question.subItems" :key="subIndex">{{ sub }}</li>
            </ul>
          </template>
        </li>
      </ul>

      <ul v-if="section.resources?.length" class="fis-list mb-3">
        <li v-for="(resource, index) in section.resources" :key="index" class="mb-1">
          <a v-if="resource.href" :href="resource.href" target="_blank" rel="noopener noreferrer" class="text-primary">
            {{ resource.label }}
          </a>
          <span v-else>{{ resource.label }}</span>
        </li>
      </ul>

      <p v-if="section.warning" class="text-body-2 font-weight-medium mb-2">{{ section.warning }}</p>

      <div v-if="section.infoLinks?.length" class="mb-3">
        <p v-for="(link, index) in section.infoLinks" :key="index" class=" mb-1">
          <a :href="link.href" target="_blank" rel="noopener noreferrer" class="text-primary-dark">
            <v-icon icon="mdi-paperclip"></v-icon> {{ link.label }}
          </a>
        </p>
      </div>

      <v-checkbox v-for="item in section.checkboxes" :key="item.key" :model-value="modelValue[item.key]" hide-details
        density="compact" class="mb-2 fis-checkbox" @update:model-value="setField(item.key, $event)">
        <template #label>
          <span class="text-wrap">
            {{ item.label }}
            <template v-if="item.link">
              —
              <a :href="item.link.href" target="_blank" rel="noopener noreferrer" class="text-primary" @click.stop>
                {{ item.link.label }}
              </a>
            </template>
          </span>
        </template>
      </v-checkbox>

      <p v-if="section.footer" class="text-body-2 mt-3 mb-1">{{ section.footer }}</p>
      <p v-if="section.footerLink" class="text-caption">
        <a :href="section.footerLink.href" target="_blank" rel="noopener noreferrer" class="text-primary">
          {{ section.footerLink.label }}
        </a>
      </p>
      <v-divider class="my-3"></v-divider>
    </section>
  </div>
</template>

<script>
import {
  FFTRI_FIS_INTRO,
  FFTRI_FIS_PDF_URL,
  HEALTH_FORM_SECTIONS_FFTRI,
} from "./formulaire_info_sante_fftri.js";

export default {
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      intro: FFTRI_FIS_INTRO,
      pdf_url: FFTRI_FIS_PDF_URL,
      sections: HEALTH_FORM_SECTIONS_FFTRI,
    };
  },
  methods: {
    setField(key, value) {
      this.$emit("update:modelValue", { ...this.modelValue, [key]: value });
    },
  },
};
</script>

<style lang="scss" scoped>
.fis-list,
.fis-sublist {
  padding-left: 1.25rem;
}

.fis-checkbox :deep(.v-label) {
  opacity: 1;
}
</style>
